import React, { useEffect, useState, useRef } from 'react';
import { UserAuthContext } from '../context/AuthContext';
import MenuHead from './MenuHead';
import InputComponent from './InputComponent';
import MessagesError from './MessagesError';
import LoadingModalPage from './LoadingModalPage';
import BoxLayouAccount from './BoxLayouAccount';
import {
  EmploymentExpensesText,
  EmploymentMethodText,
  MoveExpenses,
} from './EmploymentExpensesText';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import Sidebar from './Sidebar';
import { AuthorizeText } from './AuthorizeText';
import { useTranslation } from 'react-i18next';
import { partnerTextBox } from '../context/FormSource';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { Button, Radio } from '@material-tailwind/react';

const Account = ({
  clientTextBox,
  userInputsPersonal,
  userInputsPartner,
  userInputsGeneralQuestions,
  userInputsGeneralQuestionsPartner,
  userInputsEmployment,
  userInputsEmploymentPartner,
  userInputsExpenses,
  userInputsExpensesPartner,
  userInputsEmploymentExpenses,
  userInputsEmploymentExpensesPartner,
  userInputsInvestments,
  userInputsInvestmentsPartner,
  userAuthorize,
  userAuthorizePartner,
  userInputDependants,
  userBankInf,
  userBankInfPartner,
}) => {
  const {
    user,
    updateClient,
    getClient,
    uploadFiles,
    uploadStringFiles,
    getUrlDownloadFile,
  } = UserAuthContext();
  const [userData, setUserData] = useState([]);
  const [saveDisable, setSaveDisable] = useState(true);
  const [error, setError] = useState('');
  const [updateStep, setUpdateStep] = useState();
  const [DependantsArray, setDependantsArray] = useState([]);
  const [savedForm, setSavedForm] = useState(false);
  const [savedFormSubmit, setSavedFormSubmit] = useState(false);
  const [infoSubmit, setInfoSubmit] = useState(false);
  const [isRequired, setIsRequired] = useState(true);
  const [isReadOnly, setIsreadOnly] = useState(true);
  const [userHasPaid, setUserHasPaid] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('notpaidyet');
  const [isMarried, setIsMarried] = useState(false);
  const [shouldExit, setShouldExit] = useState(false);
  const isMarriedRef = useRef(isMarried);

  const { t } = useTranslation();
  const clientId =
    'AYMPmEdXqYn2fM-5WgIm53m-eVb3lnyjIrRgrSvQ1hDtNuB14BBTqrTk3feqvWCMxSek2H7cSwBHoLfn';

  // const [declarationYear, setDeclarationYear] = useState(
  //   localStorage.getItem('declarationYear'),
  // );

  // useEffect(() => {
  //   const year = JSON.parse(localStorage.getItem('declarationYear'));
  //   if (year) {
  //     setDeclarationYear(year);
  //   }
  // }, [declarationYear]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveDisable(false);
    setInfoSubmit(false);

    const mapUserData = Object.entries(userData);
    uploadStringFiles(
      `2023/BACKUP/${user?.email ?? '_NO_EMAIL_'}/${user?.email}_${
        user?.uid
      }_${new Date().toISOString()}.json`,
      JSON.stringify(userData),
    );
    const objectFilesMap = {};

    for (const [key, val] of mapUserData) {
      const storagePath = `2023/${user?.email}/${key}/`;

      if (key.substring(key.length - 3) === 'Url' && val.length > 0) {
        const filesUploadUrl = await Promise.all(
          val.map((elem) => {
            if (elem.urlDownloadFile) {
              return elem;
            } else {
              return uploadFiles(storagePath + elem?.name, elem.FileObject);
            }
          }),
        );
        const newUrlLink = await Promise.all(
          filesUploadUrl.map(async (element, index) => {
            if (element.urlDownloadFile) {
              return element;
            } else {
              const getUrlData = await getUrlDownloadFile(element.ref);
              return {
                id: index,
                name: element.ref.name,
                urlDownloadFile: getUrlData,
              };
            }
          }),
        );
        objectFilesMap[key] = newUrlLink;
      } else {
        objectFilesMap[key] = val;
      }
    }
    setUserData(objectFilesMap);
    setUserData({ ...objectFilesMap, payment: paymentMethod });
    try {
      const clientData = { ...objectFilesMap };
      if (
        !clientData.firstName ||
        !clientData.lastName ||
        !clientData.sin ||
        !clientData.addressStreet ||
        !clientData.dob ||
        !clientData.maritalStatus
      ) {
        setSaveDisable(true);
        alert(
          'Please fill in your all required information inside Personal Information tab before saving.',
        );
        return;
      }
      if (isRequired) {
        uploadStringFiles(
          `2023/BACKUP_SUBMITTED/${user?.email}_${
            user?.uid
          }_${new Date().toISOString()}.json`,
          JSON.stringify(userData),
        );
        clientData.status = 'Submitted';
        const currentDate = new Date();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
        const year = currentDate.getFullYear();
        const dateString = `${month.toString().padStart(2, '0')}/${day
          .toString()
          .padStart(2, '0')}/${year}`;
        clientData.dateReceived = dateString;
        clientData.lastUpdated = currentDate.toISOString();
      }
      let res = await updateClient({ clientData });
      setUserData(clientData);
      console.log('Done!', res);

      if (!isRequired) {
        setSavedForm(true);
      } else {
        setSavedFormSubmit(true);
      }
    } catch (error) {
      console.log(error);
      setError(error);
    }
    setSaveDisable(true);
  };

  const handleInput = (e) => {
    setSaveDisable(false);
    setSavedForm(false);
    const id = e.target.id;
    const value = e.target.value;
    const typeInput = e.target.type;
    const currentStatus =
      userData?.status === undefined ? 'Initial' : userData?.status;

    if (typeInput === 'file') {
      const imgData = e?.target?.files;
      const fileUrl = userData[id] ? userData[id] : [];

      for (let index = 0; index < imgData.length; index++) {
        fileUrl.push({ name: imgData[index].name, FileObject: imgData[index] });
      }

      setUserData({ ...userData, [id]: fileUrl });
    } else {
      const checkInputDependence = document.getElementById(id + 'Url');
      if (id + 'Url' && value === 'No' && checkInputDependence) {
        document.getElementById(id + 'Url').value = '';
        setUserData({ ...userData, [id]: value, [id + 'Url']: [] });
      } else {
        setUserData({ ...userData, [id]: value, status: currentStatus });
      }
    }

    setSaveDisable(true);
  };

  const RemoveFileUserdata = (elementArray, index) => {
    if (userData?.[elementArray].length === 1)
      document.getElementById(elementArray).value = '';
    userData?.[elementArray].splice(index, 1);
    setUserData({ ...userData });
  };

  const CheckFileRequeired = (inp) => {
    if (userData[inp] === 'No') return false;
    if (
      userData[inp] === 'Yes' &&
      (userData[inp + 'Url']?.length === 0 ||
        userData[inp + 'Url'] === undefined)
    )
      return true;
  };

  useEffect(() => {
    const getClientById = async () => {
      const currentClient = await getClient();
      if (currentClient.exists()) {
        const addEmail = { ...currentClient.data(), email: user.email };
        setUserData(addEmail);
        console.log('Document Loaded');
      } else {
        const addEmail = { email: user.email };
        setUserData(addEmail);
        console.log('No such document!');
      }
    };
    getClientById();
  }, [getClient, user.email]);

  useEffect(() => {
    setIsreadOnly(
      userData?.status === undefined || userData?.status === 'Initial'
        ? false
        : true,
    );
    const checkArray =
      userData?.numberDependet &&
      Array.from(Array(Number(userData?.numberDependet)).keys());
    setDependantsArray(checkArray);
  }, [userData]);

  useEffect(() => {
    setUserHasPaid(userData?.paid);
  }, [userData.paid]);

  const onCreateOrder = (data, actions) => {
    console.log({ isMarried: isMarriedRef.current });
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: isMarriedRef.current ? '103.50' : '205.50',
          },
        },
      ],
    });
  };

  const onApproveOrder = (data, actions) => {
    return actions.order.capture().then((details) => {
      const name = details.payer.name.given_name;
      setUserData({ ...userData, paid: true });
      setUserData({ ...userData, payment: paymentMethod });
      setUserHasPaid(true);
      alert(
        `Payment approved by ${name}. Please save or submit the application.`,
      );
    });
  };

  const changePaymentMethod = (e) => {
    setUserHasPaid(
      e.target.value !== 'paypal' && e.target.value !== 'notpaidyet',
    );
    setPaymentMethod(e.target.value);
    setUserData({ ...userData, payment: e.target.value });
  };

  const changeIsMarried = (e) => {
    setIsMarried(e.target.value);
  };

  const saveData = (value) => {
    setIsRequired(false);
    setShouldExit(value);
  };

  useEffect(() => {
    isMarriedRef.current = isMarried;
  }, [isMarried]);

  return (
    <div className="flex flex-row">
      {!saveDisable && <LoadingModalPage loading={true} />}
      {error && <MessagesError error={error} setError={setError} />}
      <div className="flex min-h-screen">
        {infoSubmit && (
          <LoadingModalPage
            setInfoSubmit={setInfoSubmit}
            setSavedForm={setSavedForm}
            modal={true}
            title="Missing Required information/documents"
            textInside="Not all fields are filled. Please ensure you answered all questions and/or attached required documents."
          />
        )}
        {savedForm && (
          <LoadingModalPage
            exitAfter={shouldExit}
            setInfoSubmit={setInfoSubmit}
            setSavedForm={setSavedForm}
            modal={true}
            title="Saved Information"
            textInside={
              'Data saved successfully.\n\nTo submit you tax return preparation request to Merits Accounting, please complete all required fields and click submit.'
            }
          />
        )}
        {savedFormSubmit && (
          <LoadingModalPage
            setInfoSubmit={setInfoSubmit}
            setSavedForm={setSavedForm}
            modal={true}
            title="Tax Return preparation request submitted."
            textInside="Your Tax Return was successfully submitted to Merits Accounting."
          />
        )}
        <LoadingModalPage
          setInfoSubmit={setInfoSubmit}
          setSavedForm={setSavedForm}
          modal={true}
          title="Welcome to Merits Accounting"
          textInside={
            'The system does not save your information automatically! Please make sure to click Save or Save & Exit at the bottom of the page to avoid losing progress.\n\nIMPORTANT: You will only be able to submit your tax return request once you have answered all the questions and upload all documents that you are required to, and paid the deposit. If you need to pause before going through all the questions, please click on the Save & Exit button, you will be logged out of your Merits Client Account and all the information added will be saved.\n\nOur estimated time to have the draft ready and sent to you by email along with the Invoice for payment is 10 business days from the time you submitted all the required documents for your tax return. \n\nThank you for choosing our services!'
          }
        />
        <div className="w-72 bg-[#075985] border-double xl:flex hidden">
          <Sidebar
            clientTextBox={clientTextBox}
            updateStep={updateStep}
            setUpdateStep={setUpdateStep}
          />
        </div>
      </div>

      <div className="flex-1 flex-col">
        <div className="flex-1 text-red-700">
          <MenuHead
            status={
              userData?.status === undefined ? 'Initial' : userData?.status
            }
          />
        </div>
        {userData?.status === 'Filled' && (
          <div className="flex justify-center mt-10">
            <div className="shadow-md rounded-xl bg-neutral-50 p-10 ">
              <div className="flex-1 py-4 text-lg font-extrabold text-blue-900">
                Filling confirmation
              </div>
              {userData?.AdminFilesUpload?.map((e, i) => {
                return (
                  <div className="text-blue-700 underline" key={i}>
                    <a
                      href={e.urlDownloadFile}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {e.name}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className="flex justify-center">
          <form
            onSubmit={handleSubmit}
            className="w-full max-w-7xl"
            translate="no"
            autocomplete="off"
          >
            <button
              className="ml-auto mt-4 mr-4 px-2 py-1 rounded flex bg-green-600 text-white hover:bg-green-800"
              onClick={() => saveData(false)}
              variant="outlined"
              size="sm"
            >
              {t('save')}
            </button>
            <h3 className="pb-3 pl-6 text-2xl font-bold text-blue-600">
              {t('account.taxpayerInformation')}
            </h3>
            {/* Personal Information */}
            <BoxLayouAccount
              boxTitle={clientTextBox[0]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[0].id}
              collapsible
            >
              <div
                className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3"
                id="personalInformation"
              >
                {userInputsPersonal?.map((input) => (
                  <div key={input.id}>
                    <InputComponent
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                  </div>
                ))}
              </div>
              <div className="pb-2" />
            </BoxLayouAccount>
            {/* General Questions */}
            <BoxLayouAccount
              boxTitle={clientTextBox[1]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[1].id}
              collapsible
            >
              <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                {userInputsGeneralQuestions?.map((input) => (
                  <div
                    key={input.id}
                    className="flex-row justify-between content-center align-middle sm:ml-2"
                  >
                    <InputComponent
                      inputFileRequired={
                        userData[input.id + 'Url'] &&
                        userData[input.id + 'Url'].length === 0 &&
                        userData[input.id] === 'Yes'
                      }
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                    <div className="text-xs text-red-500 italic pb-2">
                      {t(input?.dependenceInfo)}
                    </div>
                    <div className="flex-col pl-3">
                      {userData?.[input.id + 'Url'] &&
                        userData?.[input.id + 'Url'].map((element, index) => {
                          return (
                            <div
                              key={index}
                              className="flex flex-row justify-start items-center cursor-pointer"
                            >
                              {' '}
                              {!isReadOnly && (
                                <IoMdCloseCircleOutline
                                  size={20}
                                  className="mr-2 text-red-600 cursor-pointer"
                                  onClick={() =>
                                    RemoveFileUserdata(input.id + 'Url', index)
                                  }
                                />
                              )}
                              <a
                                target="_filesUploadUrlnk"
                                href={element?.urlDownloadFile}
                                className="underline text-blue-400"
                                rel="noreferrer"
                              >
                                {element?.name}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ))}
              </div>
            </BoxLayouAccount>
            {/* Income */}
            <BoxLayouAccount
              boxTitle={clientTextBox[2]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[2].id}
              collapsible
            >
              <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                {userInputsEmployment?.map((input) => (
                  <div
                    key={input.id}
                    className="flex-row justify-between content-center align-middle sm:ml-2"
                  >
                    <InputComponent
                      inputFileRequired={CheckFileRequeired(input?.id)}
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                    <div className="text-xs text-red-500 italic pb-2">
                      {t(input?.dependenceInfo)}
                      {input?.fileUrlDownload && (
                        <>
                          <a
                            className="underline"
                            download
                            href={input?.fileUrlDownload}
                          >
                            {` ${t('clickHere')} `}
                          </a>
                          {t('userInputsEmployment.downloadMessage')}
                        </>
                      )}
                    </div>
                    <div className="flex-col pl-3">
                      {userData?.[input.id + 'Url'] &&
                        userData?.[input.id + 'Url'].map((element, index) => {
                          return (
                            <div
                              key={index}
                              className="flex flex-row justify-start items-center cursor-pointer"
                            >
                              <IoMdCloseCircleOutline
                                size={20}
                                className="mr-2 text-red-600 cursor-pointer"
                                onClick={() =>
                                  RemoveFileUserdata(input.id + 'Url', index)
                                }
                              />
                              <a
                                target="_filesUploadUrlnk"
                                href={element?.urlDownloadFile}
                                className="underline text-blue-400"
                                rel="noreferrer"
                              >
                                {element?.name}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ))}
              </div>
            </BoxLayouAccount>
            {/* Expenses */}
            <BoxLayouAccount
              boxTitle={clientTextBox[3]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[3].id}
              collapsible
            >
              <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                {userInputsExpenses?.map((input) => (
                  <div
                    key={input.id}
                    className="flex-row justify-between content-center align-middle sm:ml-2"
                  >
                    <InputComponent
                      inputFileRequired={CheckFileRequeired(input?.id)}
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                    <div className="text-xs text-red-500 italic pb-2">
                      {t(input?.dependenceInfo)}
                    </div>
                    <div className="flex-col pl-3">
                      {userData?.[input.id + 'Url'] &&
                        userData?.[input.id + 'Url'].map((element, index) => {
                          return (
                            <div
                              key={index}
                              className="flex flex-row justify-start items-center cursor-pointer"
                            >
                              <IoMdCloseCircleOutline
                                size={20}
                                className="mr-2 text-red-600 cursor-pointer"
                                onClick={() =>
                                  RemoveFileUserdata(input.id + 'Url', index)
                                }
                              />
                              <a
                                target="_filesUploadUrlnk"
                                href={element?.urlDownloadFile}
                                className="underline text-blue-400"
                                rel="noreferrer"
                              >
                                {element?.name}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ))}
              </div>
            </BoxLayouAccount>
            {/* Employment Expenses */}
            <BoxLayouAccount
              boxTitle={clientTextBox[4]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[4].id}
              collapsible
            >
              <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                <EmploymentExpensesText />
                {userInputsEmploymentExpenses?.map((input, index) => (
                  <div
                    key={input.id}
                    className="flex-row justify-between content-center align-middle sm:ml-2"
                  >
                    {index === 2 && <MoveExpenses />}
                    <InputComponent
                      inputFileRequired={CheckFileRequeired(input?.id)}
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                    <div className="text-xs text-red-500 italic pb-2">
                      {t(input?.dependenceInfo)}
                    </div>
                    {/* {index === 0 &&
                      userData?.employmentExpensesFlatMethod === 'Yes' && (
                        <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                          <label>
                            {t('expensesText.daysWorkedFromHome')}
                            <input
                              required={isRequired}
                              readOnly={isReadOnly}
                              id="employmentExpensesFlatMethodDays"
                              className="block w-full px-4 py-2 mb-1 text-blue-500 bg-white border rounded-md focus:blue-blue-400 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                              type="number"
                              placeholder="Days"
                              onChange={handleInput}
                              defaultValue={
                                userData?.employmentExpensesFlatMethodDays
                              }
                            />
                          </label>
                        </div>
                      )} */}
                    {index === 0 && <EmploymentMethodText />}
                    <div className="flex-col pl-3">
                      {userData?.[input.id + 'Url'] &&
                        userData?.[input.id + 'Url'].map((element, index) => {
                          return (
                            <div
                              key={index}
                              className="flex flex-row justify-start items-center cursor-pointer"
                            >
                              <IoMdCloseCircleOutline
                                size={20}
                                className="mr-2 text-red-600 cursor-pointer"
                                onClick={() =>
                                  RemoveFileUserdata(input.id + 'Url', index)
                                }
                              />
                              <a
                                target="_filesUploadUrlnk"
                                href={element?.urlDownloadFile}
                                className="underline text-blue-400"
                                rel="noreferrer"
                              >
                                {element?.name}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                    {index === 1 &&
                      userData?.employmentExpensesDetailedMethod === 'Yes' && (
                        <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                          <label>
                            List the expenses you are claiming and the amount.
                            <textarea
                              required={isRequired}
                              readOnly={isReadOnly}
                              id="employmentExpensesDetailedMethodDescribe"
                              className="block w-full px-4 py-2 mb-1 text-blue-500 bg-white border rounded-md focus:blue-blue-400 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                              placeholder="Describe"
                              onChange={handleInput}
                              defaultValue={
                                userData?.employmentExpensesDetailedMethodDescribe
                              }
                            />
                          </label>
                        </div>
                      )}
                  </div>
                ))}
              </div>
            </BoxLayouAccount>
            {/* Investments */}
            <BoxLayouAccount
              boxTitle={clientTextBox[5]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[5].id}
              collapsible
            >
              <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                {userInputsInvestments?.map((input) => (
                  <div
                    key={input.id}
                    className="flex-row justify-between content-center align-middle sm:ml-2"
                  >
                    <InputComponent
                      inputFileRequired={CheckFileRequeired(input?.id)}
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                    <div className="text-xs text-red-500 italic pb-2">
                      {t(input?.dependenceInfo)}
                      {input?.fileUrlDownload && (
                        <>
                          <a
                            className="underline"
                            download
                            href={input?.fileUrlDownload}
                          >
                            {` ${t('clickHere')} `}
                          </a>
                          {t('userInputsInvestments.downloadMessage')}
                        </>
                      )}
                    </div>
                    <div className="flex-col pl-3">
                      {userData?.[input.id + 'Url'] &&
                        userData?.[input.id + 'Url'].map((element, index) => {
                          return (
                            <div
                              disabled
                              key={index}
                              className="flex flex-row justify-start items-center cursor-pointer"
                            >
                              <IoMdCloseCircleOutline
                                size={20}
                                className="mr-2 text-red-600 cursor-pointer"
                                onClick={() =>
                                  RemoveFileUserdata(input.id + 'Url', index)
                                }
                              />
                              <a
                                target="_filesUploadUrlnk"
                                href={element?.urlDownloadFile}
                                className="underline text-blue-400"
                                rel="noreferrer"
                              >
                                {element?.name}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ))}
              </div>
            </BoxLayouAccount>
            {/* userAuthorize */}
            <BoxLayouAccount
              boxTitle={clientTextBox[6]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[6].id}
              collapsible
            >
              <div className="px-4 pb-8">
                <AuthorizeText />
                {userAuthorize?.map((input) => (
                  <div key={input.id} className="flex ml-2">
                    <InputComponent
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                  </div>
                ))}
              </div>
            </BoxLayouAccount>
            {/* userBankInf */}
            <BoxLayouAccount
              boxTitle={clientTextBox[7]}
              setUpdateStep={setUpdateStep}
              hidden={updateStep !== clientTextBox[7].id}
              collapsible
            >
              <div className="p-4">{t('account.directDeposit')}</div>
              <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                {userBankInf?.map((input) => (
                  <div
                    key={input.id}
                    className="flex-row justify-between content-center align-middle sm:ml-2"
                  >
                    <InputComponent
                      isRequired={
                        input?.requiredField === false
                          ? input?.requiredField
                          : isRequired
                      }
                      isReadOnly={isReadOnly}
                      input={input}
                      inputIdValue={userData[input.id]}
                      handleInput={handleInput}
                    />
                  </div>
                ))}
              </div>
              <div className="p-4 text-red-500">
                {t('account.directDepositWarning')}
              </div>
            </BoxLayouAccount>
            {/* Partner */}
            {(userData.maritalStatus === 'Married' ||
              userData.maritalStatus === 'Common-Law') && (
              <>
                <h3 className="pt-12 pb-3 pl-6 text-2xl font-bold text-blue-600">
                  {t('partnerTextBox.partnerInformation')}
                </h3>
                {/* Personal Information Partner */}
                <BoxLayouAccount
                  boxTitle={partnerTextBox[0]}
                  hidden={false}
                  setUpdateStep={setUpdateStep}
                  collapsible
                >
                  <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                    {userInputsPartner?.map((input) => {
                      if (
                        input?.id === 'PartnerNetIncome' &&
                        userData?.taxTogether === 'Yes'
                      ) {
                        return (
                          <div key={input?.id + 1}>
                            <InputComponent
                              inputFileRequired={
                                userData[input.id + 'Url'] &&
                                userData[input.id + 'Url'].length === 0 &&
                                userData[input.id] === 'Yes'
                              }
                              isRequired={false}
                              isReadOnly={true}
                              input={input}
                              inputIdValue=""
                              handleInput={handleInput}
                            />
                          </div>
                        );
                      } else {
                        return (
                          <div key={input?.id}>
                            <InputComponent
                              isRequired={
                                input?.requiredField === false
                                  ? input?.requiredField
                                  : isRequired
                              }
                              isReadOnly={isReadOnly}
                              input={input}
                              inputIdValue={userData[input.id]}
                              handleInput={handleInput}
                            />
                          </div>
                        );
                      }
                    })}
                    {/* <p>{percent} "% done"</p> */}
                  </div>
                  <div className="pb-2" />
                </BoxLayouAccount>
                {userData?.taxTogether === 'Yes' && (
                  <>
                    {/* userInputsGeneralQuestionsPartner */}
                    <BoxLayouAccount
                      boxTitle={partnerTextBox[1]}
                      hidden={false}
                      setUpdateStep={setUpdateStep}
                      collapsible
                    >
                      <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                        {userInputsGeneralQuestionsPartner?.map((input) => (
                          <div
                            key={input.id}
                            className="flex-row justify-between content-center align-middle sm:ml-2"
                          >
                            <InputComponent
                              isRequired={
                                input?.requiredField === false
                                  ? input?.requiredField
                                  : isRequired
                              }
                              isReadOnly={isReadOnly}
                              input={input}
                              inputIdValue={userData[input.id]}
                              handleInput={handleInput}
                            />
                            <div className="text-xs text-red-500 italic pb-2">
                              {t(input?.dependenceInfo)}
                            </div>
                            <div className="flex-col pl-3">
                              {userData?.[input.id + 'Url'] &&
                                userData?.[input.id + 'Url'].map(
                                  (element, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className="flex flex-row justify-start items-center cursor-pointer"
                                      >
                                        <IoMdCloseCircleOutline
                                          size={20}
                                          className="mr-2 text-red-600 cursor-pointer"
                                          onClick={() =>
                                            RemoveFileUserdata(
                                              input.id + 'Url',
                                              index,
                                            )
                                          }
                                        />
                                        <a
                                          target="_filesUploadUrlnk"
                                          href={element?.urlDownloadFile}
                                          className="underline text-blue-400"
                                          rel="noreferrer"
                                        >
                                          {element?.name}
                                        </a>
                                      </div>
                                    );
                                  },
                                )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </BoxLayouAccount>
                    {/* Partner Income - userInputsEmploymentPartner */}
                    <BoxLayouAccount
                      boxTitle={partnerTextBox[2]}
                      hidden={false}
                      setUpdateStep={setUpdateStep}
                      collapsible
                    >
                      <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                        {userInputsEmploymentPartner?.map((input) => (
                          <div
                            key={input.id}
                            className="flex-row justify-between content-center align-middle sm:ml-2"
                          >
                            <InputComponent
                              inputFileRequired={CheckFileRequeired(input?.id)}
                              isRequired={
                                input?.requiredField === false
                                  ? input?.requiredField
                                  : isRequired
                              }
                              isReadOnly={isReadOnly}
                              input={input}
                              inputIdValue={userData[input.id]}
                              handleInput={handleInput}
                            />
                            <div className="text-xs text-red-500 italic pb-2">
                              {t(input?.dependenceInfo)}
                              {input?.fileUrlDownload && (
                                <>
                                  <a
                                    className="underline"
                                    download
                                    href={input?.fileUrlDownload}
                                  >
                                    {` ${t('clickHere')} `}
                                  </a>
                                  {t(
                                    'userInputsEmploymentPartner.downloadMessage',
                                  )}
                                </>
                              )}
                            </div>
                            <div className="flex-col pl-3">
                              {userData?.[input.id + 'Url'] &&
                                userData?.[input.id + 'Url'].map(
                                  (element, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className="flex flex-row justify-start items-center cursor-pointer"
                                      >
                                        <IoMdCloseCircleOutline
                                          size={20}
                                          className="mr-2 text-red-600 cursor-pointer"
                                          onClick={() =>
                                            RemoveFileUserdata(
                                              input.id + 'Url',
                                              index,
                                            )
                                          }
                                        />
                                        <a
                                          target="_filesUploadUrlnk"
                                          href={element?.urlDownloadFile}
                                          className="underline text-blue-400"
                                          rel="noreferrer"
                                        >
                                          {element?.name}
                                        </a>
                                      </div>
                                    );
                                  },
                                )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </BoxLayouAccount>
                    {/* userInputsExpensesPartner */}
                    <BoxLayouAccount
                      boxTitle={partnerTextBox[3]}
                      hidden={false}
                      setUpdateStep={setUpdateStep}
                      collapsible
                    >
                      <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                        {userInputsExpensesPartner?.map((input) => (
                          <div
                            key={input.id}
                            className="flex-row justify-between content-center align-middle sm:ml-2"
                          >
                            <InputComponent
                              inputFileRequired={CheckFileRequeired(input?.id)}
                              isRequired={
                                input?.requiredField === false
                                  ? input?.requiredField
                                  : isRequired
                              }
                              isReadOnly={isReadOnly}
                              input={input}
                              inputIdValue={userData[input.id]}
                              handleInput={handleInput}
                            />
                            <div className="text-xs text-red-500 italic pb-2">
                              {t(input?.dependenceInfo)}
                            </div>
                            <div className="flex-col pl-3">
                              {userData?.[input.id + 'Url'] &&
                                userData?.[input.id + 'Url'].map(
                                  (element, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className="flex flex-row justify-start items-center cursor-pointer"
                                      >
                                        <IoMdCloseCircleOutline
                                          size={20}
                                          className="mr-2 text-red-600 cursor-pointer"
                                          onClick={() =>
                                            RemoveFileUserdata(
                                              input.id + 'Url',
                                              index,
                                            )
                                          }
                                        />
                                        <a
                                          target="_filesUploadUrlnk"
                                          href={element?.urlDownloadFile}
                                          className="underline text-blue-400"
                                          rel="noreferrer"
                                        >
                                          {element?.name}
                                        </a>
                                      </div>
                                    );
                                  },
                                )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </BoxLayouAccount>
                    {/* Employment Expenses */}
                    <BoxLayouAccount
                      boxTitle={partnerTextBox[4]}
                      setUpdateStep={setUpdateStep}
                      hidden={false}
                      collapsible
                    >
                      <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                        <EmploymentExpensesText />
                        {userInputsEmploymentExpensesPartner?.map(
                          (input, index) => (
                            <div
                              key={input.id}
                              className="flex-row justify-between content-center align-middle sm:ml-2"
                            >
                              {index === 2 && <MoveExpenses />}
                              <InputComponent
                                inputFileRequired={CheckFileRequeired(
                                  input?.id,
                                )}
                                isRequired={
                                  input?.requiredField === false
                                    ? input?.requiredField
                                    : isRequired
                                }
                                isReadOnly={isReadOnly}
                                input={input}
                                inputIdValue={userData[input.id]}
                                handleInput={handleInput}
                              />
                              <div className="text-xs text-red-500 italic pb-2">
                                {t(input?.dependenceInfo)}
                              </div>
                              {/* {index === 0 &&
                                userData?.PartnerEmploymentExpensesFlatMethod ===
                                  'Yes' && (
                                  <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                                    <label>
                                      {t('expensesText.daysWorkedFromHome')}
                                      <input
                                        required={isRequired}
                                        readOnly={isReadOnly}
                                        id="PartnerEmploymentExpensesFlatMethodDays"
                                        className="block w-full px-4 py-2 mb-1 text-blue-500 bg-white border rounded-md focus:blue-blue-400 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                        type="number"
                                        placeholder="Days"
                                        onChange={handleInput}
                                        defaultValue={
                                          userData?.PartnerEmploymentExpensesFlatMethodDays
                                        }
                                      />
                                    </label>
                                  </div>
                                )} */}
                              {index === 0 && <EmploymentMethodText />}
                              <div className="flex-col pl-3">
                                {userData?.[input.id + 'Url'] &&
                                  userData?.[input.id + 'Url'].map(
                                    (element, index) => {
                                      return (
                                        <div
                                          key={index}
                                          className="flex flex-row justify-start items-center cursor-pointer"
                                        >
                                          <IoMdCloseCircleOutline
                                            size={20}
                                            className="mr-2 text-red-600 cursor-pointer"
                                            onClick={() =>
                                              RemoveFileUserdata(
                                                input.id + 'Url',
                                                index,
                                              )
                                            }
                                          />
                                          <a
                                            target="_filesUploadUrlnk"
                                            href={element?.urlDownloadFile}
                                            className="underline text-blue-400"
                                            rel="noreferrer"
                                          >
                                            {element?.name}
                                          </a>
                                        </div>
                                      );
                                    },
                                  )}
                              </div>
                              {index === 1 &&
                                userData?.PartnerEmploymentExpensesDetailedMethod ===
                                  'Yes' && (
                                  <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                                    <label>
                                      List the expenses you are claiming and the
                                      amount.
                                      <textarea
                                        required={isRequired}
                                        readOnly={isReadOnly}
                                        id="PartneremploymentExpensesDetailedMethodDescribe"
                                        className="block w-full px-4 py-2 mb-1 text-blue-500 bg-white border rounded-md focus:blue-blue-400 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                        placeholder="Days"
                                        onChange={handleInput}
                                        defaultValue={
                                          userData?.employmentExpensesDetailedMethodDescribe
                                        }
                                      />
                                    </label>
                                  </div>
                                )}
                            </div>
                          ),
                        )}
                      </div>
                    </BoxLayouAccount>
                    {/* userInputsInvestmentsPartner */}
                    <BoxLayouAccount
                      boxTitle={partnerTextBox[5]}
                      hidden={false}
                      setUpdateStep={setUpdateStep}
                      collapsible
                    >
                      <div className="grid sm:grid-cols-1 sm:gap-6 m-4 xl:m-3 text-left p-4">
                        {userInputsInvestmentsPartner?.map((input) => (
                          <div
                            key={input.id}
                            className="flex-row justify-between content-center align-middle sm:ml-2"
                          >
                            <InputComponent
                              inputFileRequired={CheckFileRequeired(input?.id)}
                              isRequired={
                                input?.requiredField === false
                                  ? input?.requiredField
                                  : isRequired
                              }
                              isReadOnly={isReadOnly}
                              input={input}
                              inputIdValue={userData[input.id]}
                              handleInput={handleInput}
                            />
                            <div className="text-xs text-red-500 italic pb-2">
                              {t(input?.dependenceInfo)}
                              {input?.fileUrlDownload && (
                                <>
                                  <a
                                    className="underline"
                                    download
                                    href={input?.fileUrlDownload}
                                  >
                                    {` ${t('clickHere')} `}
                                  </a>
                                  {t(
                                    'userInputsInvestmentsPartner.downloadMessage',
                                  )}
                                </>
                              )}
                            </div>
                            <div className="flex-col pl-3">
                              {userData?.[input.id + 'Url'] &&
                                userData?.[input.id + 'Url'].map(
                                  (element, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className="flex flex-row justify-start items-center cursor-pointer"
                                      >
                                        <IoMdCloseCircleOutline
                                          size={20}
                                          className="mr-2 text-red-600 cursor-pointer"
                                          onClick={() =>
                                            RemoveFileUserdata(
                                              input.id + 'Url',
                                              index,
                                            )
                                          }
                                        />
                                        <a
                                          target="_filesUploadUrlnk"
                                          href={element?.urlDownloadFile}
                                          className="underline text-blue-400"
                                          rel="noreferrer"
                                        >
                                          {element?.name}
                                        </a>
                                      </div>
                                    );
                                  },
                                )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </BoxLayouAccount>
                    {/* userAuthorize */}
                    <BoxLayouAccount
                      boxTitle={partnerTextBox[6]}
                      setUpdateStep={setUpdateStep}
                      hidden={false}
                      collapsible
                    >
                      <div>
                        <AuthorizeText />
                        {userAuthorizePartner?.map((input) => (
                          <div key={input.id} className="flex ml-2 mb-4">
                            <InputComponent
                              isRequired={
                                input?.requiredField === false
                                  ? input?.requiredField
                                  : isRequired
                              }
                              isReadOnly={isReadOnly}
                              input={input}
                              inputIdValue={userData[input.id]}
                              handleInput={handleInput}
                            />
                          </div>
                        ))}
                      </div>
                    </BoxLayouAccount>
                    {/* userBankInfPartner */}
                    <BoxLayouAccount
                      boxTitle={partnerTextBox[7]}
                      setUpdateStep={setUpdateStep}
                      hidden={updateStep !== clientTextBox[7].id}
                      collapsible
                    >
                      <div className="p-4">{t('account.directDeposit')}</div>
                      <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                        {userBankInfPartner?.map((input) => (
                          <div
                            key={input.id}
                            className="flex-row justify-between content-center align-middle sm:ml-2"
                          >
                            <InputComponent
                              isRequired={
                                input?.requiredField === false
                                  ? input?.requiredField
                                  : isRequired
                              }
                              isReadOnly={isReadOnly}
                              input={input}
                              inputIdValue={userData[input.id]}
                              handleInput={handleInput}
                            />
                          </div>
                        ))}
                      </div>
                      <div className="p-4 text-red-500">
                        {t('account.directDepositWarning')}
                      </div>
                    </BoxLayouAccount>
                  </>
                )}
              </>
            )}
            {/* Dependant */}
            {userData?.numberDependet > 0 && (
              <>
                <h3 className="pt-12 pb-3 pl-6 text-2xl font-bold text-blue-600">
                  Dependant(s) Information
                </h3>
                {/* Personal Information Dependant */}
                {DependantsArray?.map((e) => {
                  return (
                    <div key={e}>
                      <BoxLayouAccount
                        boxTitle="Dependant Information"
                        hidden={false}
                        setUpdateStep={setUpdateStep}
                        collapsible
                      >
                        <div className="grid sm:grid-cols-3 sm:gap-6 m-4 xl:m-3">
                          {userInputDependants?.map((input) => (
                            <div key={input?.id}>
                              <label className="text-base block font-semibold text-gray-800">
                                {t(input.label)}
                              </label>
                              <input
                                readOnly={isReadOnly}
                                id={input.id + e}
                                className="block w-full px-4 py-2 mb-1 text-blue-500 bg-white border rounded-md focus:blue-blue-400 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                type={input.type}
                                placeholder={t(input.placeholder)}
                                onChange={handleInput}
                                defaultValue={userData?.[input?.id + e]}
                                minLength={input.minLenght}
                                maxLength={input.maxLenght}
                                pattern={input?.pattern}
                                required={input?.requiredField}
                              />
                            </div>
                          ))}
                          {/* <p>{percent} "% done"</p> */}
                        </div>
                        <div className="pb-2" />
                      </BoxLayouAccount>
                    </div>
                  );
                })}
              </>
            )}
            <div className="my-6">
              <button
                disabled={isReadOnly}
                onClick={() => {
                  saveData(true);
                }}
                className="cursor-pointer w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-blue-500 rounded-md hover:bg-blue-900 focus:outline-none focus:bg-blue-600 disabled:bg-slate-600"
              >
                {t('saveExit')}
              </button>
              <div>
                <div className="flex flex-col my-4 border-2 rounded-md p-4 ml-4">
                  <div className="mb-2 font-bold">
                    {t('paymentMethods.payment')}
                  </div>
                  <div>
                    <div>{t('paymentMethods.total')}</div>
                    <div>
                      {t('paymentMethods.single')}: $100 CAD{' '}
                      {t('paymentMethods.taxes')}
                    </div>
                    <div>
                      {t('paymentMethods.married')}: $200 CAD{' '}
                      {t('paymentMethods.taxes')}
                    </div>
                    <div>{t('paymentMethods.business')}</div>
                    <div className="font-bold">
                      {t('paymentMethods.nonRefundable')}
                    </div>
                  </div>
                  <hr className="my-3" />
                  <div>
                    {paymentMethod === 'paypal' && (
                      <div>
                        <b>{t('paymentMethods.dueNow')}:</b>
                        <div>
                          {t('paymentMethods.single')}: $100 CAD ($100 + $3.50
                          PayPal fee) {t('paymentMethods.taxes')}
                        </div>
                        <div>
                          {t('paymentMethods.married')}: $200 CAD ($200 + $5.50
                          PayPal fee) {t('paymentMethods.taxes')}
                        </div>
                        <div>
                          <Radio
                            name="iscouple"
                            label="Single"
                            value={false}
                            onClick={changeIsMarried}
                            defaultChecked
                          />
                          <Radio
                            name="iscouple"
                            label="Married"
                            value={true}
                            onClick={changeIsMarried}
                          />
                        </div>
                      </div>
                    )}
                    {paymentMethod === 'etransfer' && (
                      <div>
                        <b>{t('paymentMethods.dueNow')}</b>
                        <div>
                          {t('paymentMethods.single')}: $100 CAD{' '}
                          {t('paymentMethods.taxes')}
                        </div>
                        <div>
                          {t('paymentMethods.married')}: $200 CAD{' '}
                          {t('paymentMethods.taxes')}
                        </div>
                        <div>{t('paymentMethods.business')}</div>
                      </div>
                    )}
                    {paymentMethod === 'notpaidyet' && (
                      <div>
                        <b>{t('paymentMethods.notpaidyet.description')}</b>
                      </div>
                    )}
                  </div>
                  <hr className="my-3" />
                  <div className="mb-4">
                    {paymentMethod === 'paypal' && (
                      <div>{t('paymentMethods.paypal.description')}</div>
                    )}
                    {paymentMethod === 'etransfer' && (
                      <div className="flex flex-col gap-4">
                        <div className="font-bold">
                          {t('paymentMethods.etransfer.description')}
                        </div>
                        <div>{t('paymentMethods.etransfer.notice')}</div>
                        {/* <div>{t('paymentMethods.etransfer.process')}</div> */}
                      </div>
                    )}
                    {paymentMethod === 'alreadypaid' && (
                      <div>{t('paymentMethods.alreadypaid.description')}</div>
                    )}
                  </div>
                  <div className="flex gap-12">
                    <Radio
                      name="type"
                      label="Not Paid Yet"
                      value="notpaidyet"
                      onClick={changePaymentMethod}
                      defaultChecked
                    />
                    <Radio
                      name="type"
                      label="Pay Now (PayPal)"
                      value="paypal"
                      onClick={changePaymentMethod}
                    />
                    <Radio
                      name="type"
                      label="e-transfer"
                      value="etransfer"
                      onClick={changePaymentMethod}
                    />
                    <Radio
                      name="type"
                      label="Already Paid"
                      value="alreadypaid"
                      onClick={changePaymentMethod}
                    />
                  </div>
                </div>
                <div className="flex flex-col my-4 mx-auto">
                  <PayPalScriptProvider
                    options={{
                      clientId,
                      currency: 'CAD',
                      intent: 'capture',
                    }}
                  >
                    <PayPalButtons
                      style={{ layout: 'horizontal' }}
                      disableMaxWidth={true}
                      tagline={false}
                      createOrder={(data, actions) =>
                        onCreateOrder(data, actions)
                      }
                      onApprove={(data, actions) =>
                        onApproveOrder(data, actions)
                      }
                    />
                  </PayPalScriptProvider>
                </div>
                <Button
                  type="submit"
                  disabled={isReadOnly || !userHasPaid}
                  onClick={() => {
                    setInfoSubmit(true);
                    setIsRequired(true);
                    uploadStringFiles(
                      `2023/BACKUP_TRIED_SUBMIT/${
                        user?.email ?? '_NO_EMAIL_'
                      }/${user?.email}_${
                        user?.uid
                      }_${new Date().toISOString()}.json`,
                      JSON.stringify(userData),
                    );
                  }}
                  className="h-12 cursor-pointer w-full mt-2 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-blue-600 rounded-md hover:bg-blue-900 focus:outline-none focus:bg-blue-600 disabled:bg-slate-600"
                >
                  {t('submit')}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Account;
